const DIALOG = require("./constants/dialog");

module.exports = {
	DIALOG
};
